module.exports = __webpack_public_path__ + "media/images/partners/code_club_square-e2eac7db239c78b102ce4d5503c59c91.svg";